/**
* Main App
*/
import React from 'react';
import { Provider } from 'react-redux';
import {  BrowserRouter as Router, Route, Switch , Redirect, useHistory, useLocation } from 'react-router-dom';
import NoAccess from '../components/NoAccess';
import Login from '../containers/Auth/Login';
import OTP from '../containers/Auth/OTP';
import Home from '../containers/Home';
import LandingPage from '../containers/LandingPage';
import RegisterScreens from '../containers/RegisterScreens';
import Dashboard from '../containers/Dashboard';
import Profile from '../containers/Profile';
import Verification from '../containers/Verification';
import store from '../store'
import { getFromLocalStorage } from '../utils/Helpers';

const Routes = () => {

	const history = useHistory();
	const loc = useLocation();

	if (loc?.hash?.startsWith('#!')) {
		const path = loc.hash.replaceAll('#!', '');
		if (path) {
			history.push(path, { replace: true });
		}
	}

	const checkRoutes = () => {
		const token = getFromLocalStorage("token");
		if (token?.step === 'register') {
			return <Route path="/register" component={RegisterScreens} />
		} else if (token?.step === 'dashboard') {
			return <>
				<Route path="/dashboard" component={Dashboard} />
				<Route path="/profile" component={Profile} />
			</>
		}
	}

	return (
		<Provider store={store}>
			<Switch>
				<Route path="/" exact component={Home} />
				<Route path="/home" component={Home} />
				<Route path="/landingPage" component={LandingPage} />
				<Route path="/verification" component={Verification} />
				{checkRoutes()}
				<Route path={`/*`} component={NoAccess} />
			</Switch>
		</Provider>
	)
};

export default Routes;
